<template>
  <el-dialog title="消息详情" append-to-body :close-on-click-modal="false" :visible.sync="visible" width="976px">
      <h3 class="msgTitle">{{detail.msgTitle}}</h3>
      <div class="desc">
        <span class="author">发布人：{{detail.creatorName}}</span>
        <span class="type">发布时间：{{detail.createTime}}</span>
      </div>
      <div class="content" v-html="detail.msgContent"></div>
  </el-dialog>
</template>

<script>
import { dateFtt } from "@/utils";
export default {
  data() {
    return {
      visible: false,
      detail:{}
    };
  },
  methods: {
    init(obj) {
      this.visible = true;
      obj.createTime = dateFtt(new Date(obj.createTime))
      this.detail = obj;
    }
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body{
  padding-top: 0;
  padding-bottom: 24px;
}
.msgTitle {
      text-align: center;
      font-size: 24px;
      font-weight: bold;
      color: #333;
      padding-top: 21px;
      padding-bottom: 10px;
    }
    .desc {
      text-align: center;
      color: #999;
      font-size: 12px;
      .author {
        margin: 0 30px;
      }
    }
    .content {
      margin-top: 15px;
      height: 432px;
      background: #EEF4F9;
      border-radius: 8px;
      padding: 16px;
      overflow: auto;
    }
</style>
